import { render } from "./TheAlarmTypesGenerals.vue?vue&type=template&id=58c8e277"
import script from "./TheAlarmTypesGenerals.vue?vue&type=script&lang=js"
export * from "./TheAlarmTypesGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__